import { State as ListState, reducer as listReducer } from "./list";

import { combineReducers } from "redux";

export interface State {
    userManagement: {
        list: ListState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
});
